function formatSec(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '0.0s';
  return `${v.toFixed(1)}s`;
}

/**
 * Summarize narration_timings after TTS + alignment.
 */
export function NarrationSyncOutline({ rendered, narrationTimings }) {
  const timings = narrationTimings || rendered?.narration_timings || [];
  const elements = rendered?.elements || [];

  if (!timings.length) {
    return (
      <p className="text-sm text-slate-500">
        No narration timings yet — run preview narration (TTS + WhisperX).
      </p>
    );
  }

  const total = timings.reduce((s, t) => s + (Number(t.duration) || 0), 0);
  const byId = Object.fromEntries(elements.map((el) => [String(el.id), el]));

  return (
    <div>
      <p className="text-xs text-slate-500 mb-3">
        {timings.length} narrated clip(s) · {formatSec(total)} total · global clock aligned
      </p>
      <ol className="space-y-2 font-mono text-[12px]">
        {timings.map((row, idx) => {
          const el = byId[String(row.element_id || row.block_id || '')];
          const label = el?.content || el?.text || row.label || row.element_id || `Clip ${idx + 1}`;
          const start = Number(row.start ?? row.global_start ?? 0);
          const dur = Number(row.duration ?? 0);
          return (
            <li
              key={row.element_id || row.block_id || idx}
              className="rounded border border-slate-800 bg-slate-900/50 px-2.5 py-2"
            >
              <div className="flex flex-wrap items-baseline gap-2">
                <span className="text-slate-600 w-5 text-right shrink-0">{idx + 1}.</span>
                <span className="text-amber-400/90 shrink-0">
                  {formatSec(start)} → {formatSec(start + dur)}
                </span>
                <span className="text-slate-200 line-clamp-2">{label}</span>
              </div>
              {row.text || row.narration ? (
                <p className="text-[11px] text-slate-500 mt-1 pl-7 line-clamp-2">
                  {row.text || row.narration}
                </p>
              ) : null}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
